import React, { Component } from 'react'
import Header from '../components/Header'

export default class View extends Component {
  render() {
    return (
      <div>
        <Header />
        View</div>
    )
  }
}
